import { Stack, Tooltip, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import useLink from 'pages/Documents/hooks/use-link'

const ProcessLink = ({process}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { go } = useLink()
  if (!process.document) {
    return null
  }
  return (
    <Tooltip title={t(`audin_document.report_type.${process.document.type.toLowerCase()}`)} placement={'top'} arrow>
      <Stack
        onClick={async() => go(process.document.id)}
        sx={{
          borderRadius: 2,
          border: `1px solid ${theme.palette.grey[200]}`,
          fontSize: 12,
          padding: '5px 10px',
          cursor: 'pointer'
        }}
        >
        {
          t('projects.process.link_document', { name: process.document.name.toLowerCase() })
        }
      </Stack>
    </Tooltip>
  )
}

export default ProcessLink